import * as types from "../actions/actionTypes";
import initialState from "../store/initialState";

export default function voortgangsrapportReducer(state = initialState.voortgangsrapportLoaded, action) {
	switch (action.type) {
		case types.VOORTGANGSRAPPORT_LOADED: {
			return Object.assign({}, state,
				{
					hasValidationErrors: action.body.hasValidationErrors,
					isLoaded: action.body.isLoaded
				});
		}

		default:
			return state;
	}
}